<template>
  <div>
    <b-input
        v-model="inputValue"
        style="font-size: 16px; width: 100px"
        @change="event => changePlace(event)">
    </b-input>
  </div>
</template>

<script>
import { BookAdapterMixin } from "@/mixins/Book/BookAdapterMixin";

/** Место хранится в строке, чтобы поле не показывало NaN на пустом значении. */
const toPlaceString = (place) => (Number.isFinite(place) ? String(place) : '0');

/**
 * Поле места команды.
 *
 * Введённое значение живёт в компоненте, поэтому в списке у него обязан быть
 * key по team_id: после пересортировки (место меняет порядок строк) Vue иначе
 * переиспользует инстанс, и значение достанется другой команде. На случай
 * переиспользования поле дополнительно сбрасывается по смене team_id.
 */
export default {
  name: "PlaceInput",
  mixins: [BookAdapterMixin],
  data() {
    return {
      inputValue: toPlaceString(this.$props.defaultPlace),
      previousValue: toPlaceString(this.$props.defaultPlace)
    };
  },
  props: {
    defaultPlace: {
      type: Number,
      default: 0
    },
    teamId: {
      type: Number,
      default: 0
    },
    matchId: {
      type: Number,
      default: 0
    },
  },
  watch: {
    // место может прийти автоматически (команда выбыла) — поле должно это показать
    defaultPlace() {
      this.resetFromProps();
    },
    // в строку подставили другую команду — её место не должно унаследоваться
    teamId() {
      this.resetFromProps();
    },
  },
  methods: {
    resetFromProps() {
      const value = toPlaceString(this.defaultPlace);
      this.inputValue = value;
      this.previousValue = value;
    },
    async changePlace(place) {
      try {
        await this.storePlace({
          teamId: this.teamId,
          place: Number.parseInt(place),
          type: 'live',
          matchId: this.$props.matchId
        });
        this.previousValue = this.inputValue;
      } catch (error) {
        this.inputValue = this.previousValue;
      }
    }
  },
}
</script>
